export const queueHelpers = {
  formatQueueNumber: (queueNumber: string): string => {
    return queueNumber.toUpperCase();
  },

  formatStatus: (status: string): { text: string; color: string } => {
    const statusMap = {
      waiting: { text: 'Menunggu', color: 'blue' },
      called: { text: 'Dipanggil', color: 'yellow' },
      in_progress: { text: 'Sedang Dilayani', color: 'green' },
      completed: { text: 'Selesai', color: 'gray' },
      cancelled: { text: 'Dibatalkan', color: 'red' },
      skipped: { text: 'Dilewati', color: 'orange' }
    };
    return statusMap[status as keyof typeof statusMap] || { text: status, color: 'gray' };
  },

  formatPriority: (priority: number): { text: string; color: string } => {
    const priorityMap = {
      1: { text: 'Normal', color: 'blue' },
      2: { text: 'Prioritas', color: 'yellow' },
      3: { text: 'Darurat', color: 'red' }
    };
    return priorityMap[priority as keyof typeof priorityMap] || { text: 'Normal', color: 'blue' };
  },

  formatServiceType: (serviceType: string): string => {
    const serviceMap = {
      doctor: 'Dokter',
      nurse: 'Perawat',
      lab: 'Laboratorium',
      pharmacy: 'Apotek',
      radiology: 'Radiologi',
      dental: 'Gigi',
      midwife: 'Bidan'
    };
    return serviceMap[serviceType as keyof typeof serviceMap] || serviceType;
  }
};
